import {
  LISTA_VIDEOS,
  LISTA_VIDEOS_SUCESSO,
  LISTA_VIDEOS_ERRO,
  CRIA_VIDEO,
  CRIA_VIDEO_SUCESSO,
  EDITA_VIDEO,
  EDITA_VIDEO_SUCESSO,
  DELETA_VIDEO,
  DELETA_VIDEO_SUCESSO,
  TOGGLE_ATIVO_VIDEO,
  TOGGLE_ATIVO_VIDEO_SUCESSO,
  VIDEOS_ERRO,
} from 'constants/ActionTypes';

export const listaVideos = (pagina = 1, tamanhoPagina = 20, busca = '') => ({
  type: LISTA_VIDEOS,
  payload: { pagina, tamanhoPagina, busca },
});

export const listaVideosSucesso = (data) => ({
  type: LISTA_VIDEOS_SUCESSO,
  payload: data,
});

export const listaVideosErro = (mensagem) => ({
  type: LISTA_VIDEOS_ERRO,
  payload: mensagem,
});

export const criaVideo = (formData) => ({
  type: CRIA_VIDEO,
  payload: formData,
});

export const criaVideoSucesso = () => ({
  type: CRIA_VIDEO_SUCESSO,
});

export const editaVideo = (id, formData) => ({
  type: EDITA_VIDEO,
  payload: { id, formData },
});

export const editaVideoSucesso = () => ({
  type: EDITA_VIDEO_SUCESSO,
});

export const deletaVideo = (id) => ({
  type: DELETA_VIDEO,
  payload: { id },
});

export const deletaVideoSucesso = () => ({
  type: DELETA_VIDEO_SUCESSO,
});

export const toggleAtivoVideo = (id) => ({
  type: TOGGLE_ATIVO_VIDEO,
  payload: { id },
});

export const toggleAtivoVideoSucesso = () => ({
  type: TOGGLE_ATIVO_VIDEO_SUCESSO,
});

export const videosErro = (mensagem) => ({
  type: VIDEOS_ERRO,
  payload: mensagem,
});
